import {
  CREATE_MANPOWER_REMINDER_SUCCESS,
  FETCH_MANPOWER_REMINDER_SUCCESS,
  GET_MANPOWER_REMINDER_SUCCESS,
  SAVE_MANPOWER_REMINDER_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_MANPOWER_REMINDER_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_MANPOWER_REMINDER_SUCCESS: {
      const query = {...state.query};
      // query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        // total: action.total,
      }
    }

    case CREATE_MANPOWER_REMINDER_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_MANPOWER_REMINDER_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
